import { twMerge } from "tailwind-merge";
import { Icon } from "@sellar-io/components";
import { ProductAwardContainerType } from "../SpotlightProductCard.shared";
type AwardTier = "gold" | "silver" | "bronze";

const tierStyles: Record<
  AwardTier,
  { color: string; label: string; iconColor: string }
> = {
  gold: {
    color: "text-yellow-600",
    label: "Gold",
    iconColor: "text-yellow-600",
  },
  silver: {
    color: "text-gray-500",
    label: "Silver",
    iconColor: "text-gray-500",
  },
  bronze: {
    color: "text-orange-700",
    label: "Bronze",
    iconColor: "text-orange-700",
  },
};

export const AwardBadge = ({
  tier,
  type,
  className,
}: {
  tier: AwardTier;
  type: ProductAwardContainerType;
  className?: string;
}) => {
  const { color, label, iconColor } = tierStyles[tier];

  return (
    <div
      className={twMerge(
        "inline-flex items-center justify-center gap-1 rounded-lg bg-neutral-50 px-1.5 py-1 outline outline-1 outline-offset-[-1px] outline-zinc-200",
        className,
      )}
    >
      <div className="flex items-center justify-start">
        <Icon icon={"LICENSE"} className={iconColor} />
        <div
          className={twMerge(
            "justify-end text-xs leading-4 font-semibold",
            color,
          )}
        >
          {label} •
        </div>
      </div>
      <div
        className={twMerge("justify-end text-xs leading-4 font-medium", color)}
      >
        {type}
      </div>
    </div>
  );
};
